import { render, staticRenderFns } from "./privacy4.vue?vue&type=template&id=c5b61da8&scoped=true"
import script from "./privacy4.vue?vue&type=script&lang=js"
export * from "./privacy4.vue?vue&type=script&lang=js"
import style0 from "./privacy4.vue?vue&type=style&index=0&id=c5b61da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b61da8",
  null
  
)

export default component.exports